// extracted by mini-css-extract-plugin
export default {"errorBox":"ErrorBanner_errorBox__ELNm1","smallToBig":"ErrorBanner_smallToBig__d6MiA"};